import { useState, useEffect } from "react";

import { Container, Row, Col, Table } from "react-bootstrap";
import Money from "../Parts/Money";
import api from "../PowerShadesAPI";
import { getQuoteType } from "../Quote/QuoteObjectExtensions.ts";

const QuoteHistoryHeadRow = (props) => (
	<tr className="bold-row">
		<th>Date / Time</th>
		<th>Description</th>
		<th>User Name</th>
		<th>User Email</th>
		<th>MSRP Snapshot</th>
	</tr>
);

const QuoteHistoryEntryRow = (props) => {
	const date = new Date(props.entry.time * 1000);

	return (
		<tr>
			<td>{date.toLocaleString()}</td>
			<td>{props.entry.description}</td>
			<td>{props.entry.user_name}</td>
			<td>{props.entry.user_email}</td>
			<td>
				<Money>{props.entry.msrp_snapshot}</Money>
			</td>
		</tr>
	);
};

const QuoteHistoryTable = (props) => {
	const entry_rows = [];

	props.entries.forEach((entry) => {
		entry_rows.push(<QuoteHistoryEntryRow key={entry.ID} entry={entry} />);
	});

	return (
		<Table responsive size="sm" bordered hover className={props.quoteType}>
			<tbody>
				<QuoteHistoryHeadRow />

				{entry_rows}
			</tbody>
		</Table>
	);
};

const QuoteHistory = (props) => {
	const [entries, setEntries] = useState([]);
	const quoteType = getQuoteType(props.newQuote);

	useEffect(() => {
		api.getQuoteHistory(props.quote).then((resp) => {
			resp.data.entries && setEntries(resp.data.entries);
		});
	}, []);
	
	return (
		<div className="modal-holder">
			<div className="quote-history-modal">
				<Container className="local-bootstrap">
					<Row>
						<Col>
							<h4 className={`text-${quoteType}`}>Quote History</h4>
						</Col>
					</Row>
					<Row>
						<Col>
							<QuoteHistoryTable quoteType={quoteType} entries={entries} />
						</Col>
					</Row>

					<div className="button-holder">
						<button
							style={{ paddingLeft: "16px", paddingRight: "16px" }}
							type="button"
							className={`btn btn-green pt-0 pb-0 btn-${quoteType}`}
							onClick={props.onClose}
						>
							Done
						</button>
					</div>
				</Container>
			</div>
		</div>
	);
};

export default QuoteHistory;
